export default "__VITE_ASSET__DR30k_Sa__"